//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { atuosphereList, atmosphereDelete, atmosphereStatusApi } from '@/api/marketing';
import { checkPermi } from '@/utils/permission';
import { handleDeleteTable } from '@/libs/public'; // 权限判断函数
import optionDateTimePicker from '@/components/optionDateTimePicker';
export default {
  name: 'HoneyList',
  components: {
    optionDateTimePicker: optionDateTimePicker
  },
  data: function data() {
    return {
      props: {
        multiple: false,
        emitPath: false
      },
      Loading: false,
      dialogVisible: false,
      listLoading: false,
      receiveType: 0,
      id: '',
      categoryList: [],
      labelList: [],
      tableData: {
        data: [],
        total: 0
      },
      tableFrom: {
        page: 1,
        limit: 20,
        name: '',
        runningStatus: '',
        starttime: '',
        endtime: '',
        type: null
      },
      name: '',
      type: 0,
      isShow: false,
      timeVal: []
    };
  },
  computed: {
    activityTpye: function activityTpye() {
      return this.$route.path.indexOf('border') !== -1 ? 0 : 1;
    }
  },
  mounted: function mounted() {
    this.getList(1);
  },
  methods: {
    checkPermi: checkPermi,
    onEdit: function onEdit(item) {
      localStorage.setItem('activitystyle', JSON.stringify(item));
      this.$router.push({
        path: this.activityTpye === 1 ? "/marketing/atmosphere/add/".concat(item.id) : "/marketing/border/add/".concat(item.id)
      });
    },
    onchangeTime: function onchangeTime(e) {
      this.timeVal = e;
      this.tableFrom.starttime = e ? e[0] : '';
      this.tableFrom.endtime = e ? e[1] : '';
      this.getList(1);
    },
    reset: function reset(formName) {
      this.timeVal = [];
      this.name = '';
      this.tableFrom = {
        page: 1,
        limit: 20,
        name: '',
        status: '',
        starttime: '',
        endtime: '',
        type: null
      };
      this.getList('');
    },
    // 删除
    handleDelete: function handleDelete(id, idx) {
      var _this = this;
      this.$modalSure("\u5220\u9664\u6D3B\u52A8\u540E\u5C06\u65E0\u6CD5\u6062\u590D\uFF0C\u8BF7\u8C28\u614E\u64CD\u4F5C!").then(function () {
        atmosphereDelete({
          id: id
        }).then(function () {
          _this.$message.success('删除成功');
          handleDeleteTable(_this.tableData.data.length, _this.tableFrom);
          _this.getList(null);
        });
      });
    },
    // 列表
    getList: function getList(num) {
      var _this2 = this;
      this.listLoading = true;
      this.tableFrom.type = this.activityTpye;
      this.tableFrom.page = num || this.tableFrom.page;
      this.tableFrom.name = encodeURIComponent(this.name);
      atuosphereList(this.tableFrom).then(function (res) {
        _this2.tableData.data = res.list;
        _this2.tableData.total = res.total;
        _this2.listLoading = false;
      }).catch(function (res) {
        _this2.listLoading = false;
      });
    },
    pageChange: function pageChange(page) {
      this.tableFrom.page = page;
      this.getList('');
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getList('');
    },
    // 修改状态
    onchangeIsShow: function onchangeIsShow(row) {
      var _this3 = this;
      atmosphereStatusApi({
        id: row.id,
        status: row.status
      }).then(function () {
        _this3.$message.success('修改成功');
        _this3.getList('');
      }).catch(function () {
        row.status = !row.status;
      });
    }
  }
};